__turbopack_context__.v({
  "bottom": "styles-module__Jvga8G__bottom",
  "brandCol": "styles-module__Jvga8G__brandCol",
  "brandLogo": "styles-module__Jvga8G__brandLogo",
  "colHeading": "styles-module__Jvga8G__colHeading",
  "colList": "styles-module__Jvga8G__colList",
  "contactLink": "styles-module__Jvga8G__contactLink",
  "contactRow": "styles-module__Jvga8G__contactRow",
  "copyright": "styles-module__Jvga8G__copyright",
  "link": "styles-module__Jvga8G__link",
  "root": "styles-module__Jvga8G__root",
  "socialLink": "styles-module__Jvga8G__socialLink",
  "socialRow": "styles-module__Jvga8G__socialRow",
  "tagline": "styles-module__Jvga8G__tagline",
  "top": "styles-module__Jvga8G__top",
});
